
import { useState } from 'react';

import { useTheme } from '@mui/material/styles';

import { STIMULUS_SUB_TABS } from '../config';


const StimulusList = () => {
	const theme = useTheme();
	const activeColor = theme?.palette?.novotalk?.$activeColor || theme?.palette?.primary?.main;
	const [activeTabIndex, setActiveTabIndex] = useState(0);
	const activeTab = STIMULUS_SUB_TABS[activeTabIndex];

	return (
		<div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
			<div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: 16 }} role="tablist">
				{STIMULUS_SUB_TABS.map((tab, idx) => (
					<button
						key={tab.key}
						type="button"
						role="tab"
						aria-selected={activeTabIndex === idx}
						aria-controls={`tabpanel-${tab.key}`}
						tabIndex={activeTabIndex === idx ? 0 : -1}
						style={{
							padding: '8px 24px',
							cursor: 'pointer',
							border: 'none',
							background: 'none',
							borderBottom: activeTabIndex === idx ? `2px solid ${activeColor}` : 'none',
							color: activeTabIndex === idx ? activeColor : '#333',
							fontWeight: activeTabIndex === idx ? 600 : 400,
							outline: 'none',
						}}
						onClick={() => setActiveTabIndex(idx)}
						id={`tab-${tab.key}`}
					>
						{tab.label}
					</button>
				))}
			</div>
			{activeTab && (
				<div
					id={`tabpanel-${activeTab.key}`}
					role="tabpanel"
					aria-labelledby={`tab-${activeTab.key}`}
					style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}
				>
					<activeTab.component />
				</div>
			)}
		</div>
	);
};

export default StimulusList;
